import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Form, Input, message, Row, Select, Spin } from "antd";
import map from "lodash/map";
import get from "lodash/get";
import lodashFilter from "lodash/filter";
import {
  BREAKDOWN_UPDATE_FAILED,
  BREAKDOWN_UPDATE_SUCCESS,
} from "../../constants/message";
import { updateBreakDowns } from "../../redux/actions/breakdownActions";
import {
  convertTimeRangeToAmPm,
  replaceMultiple,
} from "../../utilities/helpers";
import dayjs from "dayjs";

export default function BreakDownSettingForm({
  reasons,
  breakdownModal,
  toggle,
  getBreakdowns,
  filter,
  breakdowns
}) {
  const dispatch = useDispatch();
  const [modalForm] = Form.useForm();
  const isEdit = get(breakdownModal, "data.break_down_reason.id");
  const [loading, setLoading] = useState(false);
  const handleEditSubmit = (values) => {
    if (!get(filter, "template")) {
      message.error(
        replaceMultiple(BREAKDOWN_UPDATE_FAILED, {
          "{{slot}}": convertTimeRangeToAmPm(get(values, "slot")),
          "{{state}}": isEdit ? "Update" : "Add",
        })
      );
      return;
    }
    setLoading(true);

    const payload = {
      date: dayjs(get(filter, "date")).format("YYYY-MM-DD"),
      reason_id: get(values, "break_down_reason"),
      description: get(values, "break_down_description"),
      slot_id: get(values, "slot_id"),
      meta: get(values, "meta"),
      copy_to_slots: get(values, "copy_to_slots", [])
    };
    dispatch(updateBreakDowns(get(filter, "template"), payload))
      .then((result) => {
        toggle();
        getBreakdowns();
        setLoading(false);
        message.success(
          replaceMultiple(BREAKDOWN_UPDATE_SUCCESS, {
            "{{slot}}": convertTimeRangeToAmPm(get(values, "slot")),
            "{{state}}": isEdit ? "Updated" : "Added",
          })
        );
      })
      .catch(() => {
        setLoading(false);
        message.error(
          replaceMultiple(BREAKDOWN_UPDATE_FAILED, {
            "{{slot}}": convertTimeRangeToAmPm(get(values, "slot")),
            "{{state}}": isEdit ? "Update" : "Add",
          })
        );
      });
  };
  const selectReasons = map(reasons, (reason) => {
    return {
      label: get(reason, "reason", "N/A"),
      value: get(reason, "id"),
    };
  });
  return (
    <Spin spinning={loading}>
      <div className="mt-4">
      <Form
        form={modalForm}
        layout="vertical"
        initialValues={{
          break_down_reason: get(breakdownModal, "data.break_down_reason.id"),
          break_down_description: get(
            breakdownModal,
            "data.break_down_description",
            ""
          ),
          slot: convertTimeRangeToAmPm(get(breakdownModal, "data.slot")),
          copy_to_slots: get(breakdownModal, "data.copy_to_slots"),
          slot_id: get(breakdownModal, "data.slot_id"),
          meta: {
            off_time: get(breakdownModal, "data.meta.off_time", 0),
            idle_time: get(breakdownModal, "data.meta.idle_time", 0),
            count: get(breakdownModal, "data.meta.count", 0),
          },
        }}
        name="edit_record_form"
        onFinish={handleEditSubmit}
      >
        <Form.Item
          label="Day Hours"
          name="slot"
          rules={[{ required: true, message: "Please enter day hours!" }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item name="slot_id" hidden>
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col xs={8}>
            <Form.Item
              label="Idle Time"
              name={["meta", "idle_time"]}
              rules={[{ required: true, message: "Please enter idle time!" }]}
            >
              <Input type="number" disabled defaultValue={0} />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item
              label="Off Time"
              name={["meta", "off_time"]}
              rules={[{ required: true, message: "Please enter shut time!" }]}
            >
              <Input type="number" disabled defaultValue={0} />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <Form.Item
              label="Count"
              name={["meta", "count"]}
              rules={[{ required: true, message: "Please enter count!" }]}
            >
              <Input type="number" disabled defaultValue={0} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Reason"
          name="break_down_reason"
          rules={[{ required: true, message: "Please Select Reason!" }]}
        >
          <Select
            options={selectReasons}
            placeholder="Please Select Reason"
            allowClear
          />
        </Form.Item>

        <Form.Item
          label="Reason Description"
          name="break_down_description"
          rules={[
            {
              required: true,
              message: "Please enter a description for the reason!",
            },
          ]}
        >
          <Input.TextArea rows={4} placeholder="Please Enter Description" />
        </Form.Item>
        <Form.Item
          label="Copy To Slots" name="copy_to_slots">
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Please Select Copy To Slots"
            options={
              map(lodashFilter(breakdowns, b => !get(b, 'break_down_reason') &&
                get(b, 'slot_id') !== get(breakdownModal, "data.slot_id")), (breakdown) => ({ value: get(breakdown, "slot_id"), label: get(breakdown, "slot") }))
            }
          />
        </Form.Item>
        <div className="w-full bg-white pt-4 px-4">
          <div className="flex justify-end space-x-2">
            <Button
              onClick={() => {
                toggle();
              }}
              className="border-gray-300"
            >
              Close
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </div>
      </Form>
      </div>
    </Spin>
  );
}
